var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div"},[_c('Hero5Demo'),_c('feature10Demo'),_c('Team1Demo',{attrs:{"team":_vm.Items}}),_c('Logos1Demo'),_c('Footer4Demo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }